<script>
  import { hourFormat } from "@/core/services/helpers"
  import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
  import { faTimesCircle } from "@fortawesome/free-solid-svg-icons"
  import Multiselect from "vue-multiselect"

  export default {
    components: {
      FontAwesomeIcon,
      Multiselect,
    },
    props: {
      scheduleModel: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        faTimesCircle,
        dateWeekendGo: [],
        dateWeekendReturn: [],
        hourScheduleGo: "",
        hourScheduleReturn: "",
        orderOptions: [
          { id: 7, name: "Todos", label: " Todos" },
          { id: 1, name: "Segunda-feira", label: " Seg" },
          { id: 2, name: "Terça-feira", label: " Ter" },
          { id: 3, name: "Quarta-feira", label: " Qua" },
          { id: 4, name: "Quinta-feira", label: " Qui" },
          { id: 5, name: "Sexta-feira", label: " Sex" },
          { id: 6, name: "Sábado", label: " Sáb" },
          { id: 0, name: "Domingo", label: " Dom" },
        ],
        dayArrayAux: [
          { id: 1, name: "Segunda-feira", label: " Seg" },
          { id: 2, name: "Terça-feira", label: " Ter" },
          { id: 3, name: "Quarta-feira", label: " Qua" },
          { id: 4, name: "Quinta-feira", label: " Qui" },
          { id: 5, name: "Sexta-feira", label: " Sex" },
          { id: 6, name: "Sábado", label: " Sáb" },
          { id: 0, name: "Domingo", label: " Dom" },
        ],
        dayCounter: new Map([
          [
            1,
            [
              { tpdirecao: 1, count: 0 },
              { tpdirecao: 2, count: 0 },
            ],
          ],
          [
            2,
            [
              { tpdirecao: 1, count: 0 },
              { tpdirecao: 2, count: 0 },
            ],
          ],
          [
            3,
            [
              { tpdirecao: 1, count: 0 },
              { tpdirecao: 2, count: 0 },
            ],
          ],
          [
            4,
            [
              { tpdirecao: 1, count: 0 },
              { tpdirecao: 2, count: 0 },
            ],
          ],
          [
            5,
            [
              { tpdirecao: 1, count: 0 },
              { tpdirecao: 2, count: 0 },
            ],
          ],
          [
            6,
            [
              { tpdirecao: 1, count: 0 },
              { tpdirecao: 2, count: 0 },
            ],
          ],
          [
            0,
            [
              { tpdirecao: 1, count: 0 },
              { tpdirecao: 2, count: 0 },
            ],
          ],
          ["origin", 0],
          ["destiny", 0],
        ]),
      }
    },
    computed: {
      schedule() {
        return this.scheduleModel
      },
    },
    watch: {
      scheduleModel: {
        handler() {
          this.defineDayCounter()
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      /**
       * Define o contador de horários por dia da semana
       * e direção (ida e volta)
       */
      defineDayCounter() {
        this.dayCounter = new Map()
        let countGoing = 0
        let countReturn = 0
        this.dayArrayAux.forEach((day) => {
          let dayCounterGo = 0
          let dayCounterReturn = 0
          this.schedule.schedules.forEach((horario) => {
            if (horario.nudiasemana == day.id && horario.tpdirecao == 1) {
              dayCounterGo++
            }
            if (horario.nudiasemana == day.id && horario.tpdirecao == 2) {
              dayCounterReturn++
            }
          })
          this.dayCounter.set(day.id, [
            { tpdirecao: 1, count: dayCounterGo },
            { tpdirecao: 2, count: dayCounterReturn },
          ])
          countGoing += dayCounterGo
          countReturn += dayCounterReturn
        })
        this.dayCounter.set("origin", countGoing)
        this.dayCounter.set("destiny", countReturn)
      },

      /**
       * Ordena os horários de partida da linha
       * por ordem crescente
       */
      orderSchedule() {
        for (let i = 0; i < this.schedule.schedules.length; i++) {
          let k = i
          for (let j = i + 1; j < this.schedule.schedules.length; j++) {
            if (
              this.schedule.schedules[j]["hrpartida"] &&
              this.schedule.schedules[k]["hrpartida"]
            ) {
              if (
                this.schedule.schedules[j]["hrpartida"] <
                this.schedule.schedules[k]["hrpartida"]
              )
                k = j
            }
          }
          let tmp = {}
          tmp = this.schedule.schedules[i]
          this.schedule.schedules[i] = this.schedule.schedules[k]
          this.schedule.schedules[k] = tmp
        }
      },

      /**
       * Adiciona um horário de partida para a linha
       * @param {number} direction Direção do horário (1 - ida, 2 - volta)
       */
      setHour(direction) {
        let dt = []
        let hr = 0

        if (direction === 1) {
          dt = this.dateWeekendGo
          hr = this.hourScheduleGo
        } else {
          dt = this.dateWeekendReturn
          hr = this.hourScheduleReturn
        }

        let isValid = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(
          hr
        )

        if (isValid) {
          if (dt.filter((dia) => dia.id == 7).length > 0) {
            dt = this.dayArrayAux
          }

          let horarioDuplicado = []
          let horarioDuplicadoSize = 0
          dt.forEach((diaSelecionado) => {
            this.schedule.schedules.forEach((horario) => {
              if (
                horario.nudiasemana == diaSelecionado.id &&
                horario.tpdirecao == direction &&
                (horario.hrpartida === hr.concat(":00") ||
                  horario.hrpartida === hr)
              ) {
                horarioDuplicado.push(diaSelecionado.label)
              }
            })
            if (horarioDuplicadoSize < horarioDuplicado.length) {
              horarioDuplicadoSize = horarioDuplicado.length
              return
            }
            let schedule = {
              hrpartida: hr,
              nudiasemana: diaSelecionado.id,
              // nulinha: this.id,
              tpdirecao: direction,
              flsituacao: 1,
              nuextensao: null,
              nulinharamal: null,
            }

            this.schedule.schedules.push(schedule)
            this.changeScheduleForm()
            this.orderSchedule()

            this.dayCounter.get(diaSelecionado.id)[direction - 1].count++

            if (direction === 1) {
              this.dayCounter.set("origin", this.dayCounter.get("origin") + 1)
            } else {
              this.dayCounter.set("destiny", this.dayCounter.get("destiny") + 1)
            }
          })
          if (horarioDuplicado.length > 0) {
            this.$toast.error({
              title: "Erro",
              message:
                "Horário já cadastrado para " + horarioDuplicado.toString(),
            })
          }

          this.hourScheduleGo = ""
          this.hourScheduleReturn = ""
        }
      },

      /**
       * Remove um horário de partida da linha
       * @param {number} id Índice do horário na lista
       * @param {number} day Dia da semana do horário
       * @param {number} direction Direção do horário (1 - ida, 2 - volta)
       */
      deleteSchedule(id, day, direction) {
        this.schedule.schedules.splice(id, 1)
        this.changeScheduleForm()

        this.dayCounter.get(day)[direction - 1].count--
        if (direction === 1) {
          this.dayCounter.set("origin", this.dayCounter.get("origin") - 1)
        } else {
          this.dayCounter.set("destiny", this.dayCounter.get("destiny") - 1)
        }
      },

      /**
       * Formata a hora para exibição
       * @param {string} time Hora a ser formatada
       * @returns {string} Hora formatada
       */
      formatHour(time) {
        return hourFormat(time)
      },

      /**
       * Retorna o nome do dia da semana
       * @param {number} dateW Dia da semana
       * @returns {string} Nome do dia da semana
       */
      dateOfWeekend(dateW) {
        if (dateW == 1) return "Segunda-Feira"
        if (dateW == 2) return "Terça-Feira"
        if (dateW == 3) return "Quarta-Feira"
        if (dateW == 4) return "Quinta-Feira"
        if (dateW == 5) return "Sexta-Feira"
        if (dateW == 6) return "Sábado"
        if (dateW == 0) return "Domingo"
      },

      /**
       * Altera o dia da semana selecionado
       */
      changeDiaDaSemanaGo() {
        if (
          this.dateWeekendGo.length > 1 &&
          this.dateWeekendGo[0].name === "Todos"
        ) {
          this.dateWeekendGo.shift()
        } else {
          if (
            this.dateWeekendGo.filter((dia) => dia.name === "Todos").length > 0
          ) {
            this.dateWeekendGo = [{ id: 7, name: "Todos", label: " Todos" }]
          }
        }
      },

      /**
       * Altera o dia da semana selecionado
       */
      changeDiaDaSemanaReturn() {
        if (
          this.dateWeekendReturn.length > 1 &&
          this.dateWeekendReturn[0].name === "Todos"
        ) {
          this.dateWeekendReturn.shift()
        } else {
          if (
            this.dateWeekendReturn.filter((dia) => dia.name === "Todos")
              .length > 0
          ) {
            this.dateWeekendReturn = [{ id: 7, name: "Todos", label: " Todos" }]
          }
        }
      },

      /**
       * Define que o formulário foi alterado
       */
      changeScheduleForm() {
        this.$emit("changeScheduleForm")
      },
    },
  }
</script>
<template>
  <div>
    <div
      class="grid grid-flow-row gap-6 mt-5 text-xs md:grid-cols-2 lg:grid-cols-2 justify-content-between"
    >
      <div class="flex flex-col w-full items-center">
        <p>
          Número de horários da semana:
          {{ dayCounter.get("origin") }}
        </p>

        <div class="flex justify-content-between border w-full p-2">
          <div class="flex justify-content-center items-center w-full">
            <Multiselect
              v-model="dateWeekendGo"
              :options="orderOptions"
              :multiple="true"
              :close-on-select="false"
              select-label="Clique para selecionar"
              class="w-2/3"
              selected-label="Selecionado"
              deselect-label="Clique para remover"
              track-by="name"
              label="name"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Dias da semana"
              :preselect-first="false"
              @select="changeDiaDaSemanaGo"
            >
              <template #selection="{ values, isOpen }">
                <span
                  v-if="values.length"
                  v-show="!isOpen"
                  class="multiselect__single"
                >
                  {{
                                        values
                                            .map((dia) => dia.label)
                                            .toString()
                                    }}
                </span>
              </template>
            </Multiselect>
            <input
              v-model="hourScheduleGo"
              style="padding: 7px 10px !important"
              class="pl-4 filter-search ml-2 mr-2 w-1/4 h-9"
              placeholder="Horário"
              type="time"
            >
            <div
              class="flex items-center justify-center w-32 ml-1 form-submit cursor-pointer"
              @click="setHour(1)"
            >
              Adicionar
            </div>
          </div>
        </div>

        <div class="w-full items-center p-2">
          <div class="flex flex-col w-full">
            <div
              v-for="(day, index) in dayArrayAux"
              :key="index"
              class="flex w-full border justify-content-between items-center mb-1"
            >
              <div class="w-1/3 p-2">
                {{ day.name }}
                <p>
                  Núm. horários do dia:
                  {{ dayCounter.get(day.id)[0].count }}
                </p>
              </div>
              <div class="w-2/3 p-2 flex flex-wrap">
                <div v-for="(horario, i) in schedule.schedules" :key="i">
                  <div
                    v-if="
                                            horario.tpdirecao == 1 &&
                                            horario.nudiasemana == day.id
                                        "
                    class="flex items-center justify-content-center mr-2"
                  >
                    <div class="timer-clock-lines">
                      {{ formatHour(horario.hrpartida) }}
                    </div>
                    <FontAwesomeIcon
                      class="text-red-500 cursor-pointer"
                      :icon="faTimesCircle"
                      @click="
                                                deleteSchedule(i, day.id, 1)
                                            "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col w-full items-center">
        <p>
          Número de horários da semana:
          {{ dayCounter.get("destiny") }}
        </p>

        <div class="flex justify-content-between border w-full p-2">
          <div class="flex justify-content-center w-full items-center">
            <Multiselect
              v-model="dateWeekendReturn"
              :options="orderOptions"
              :multiple="true"
              :close-on-select="false"
              select-label="Clique para selecionar"
              class="w-2/3"
              selected-label="Selecionado"
              deselect-label="Clique para remover"
              track-by="name"
              label="name"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Dias da semana"
              :preselect-first="false"
              @select="changeDiaDaSemanaReturn"
            >
              <template #selection="{ values, isOpen }">
                <span
                  v-if="values.length"
                  v-show="!isOpen"
                  class="multiselect__single"
                >
                  {{
                                        values
                                            .map((dia) => dia.label)
                                            .toString()
                                    }}
                </span>
              </template>
            </Multiselect>
            <input
              v-model="hourScheduleReturn"
              style="padding: 7px 10px !important"
              class="pl-4 filter-search ml-2 mr-2 w-1/4 h-9"
              placeholder="Horário"
              type="time"
            >
            <div
              class="flex items-center justify-center w-32 ml-1 form-submit cursor-pointer"
              @click="setHour(2)"
            >
              Adicionar
            </div>
          </div>
        </div>

        <div class="w-full items-center p-2">
          <div class="flex flex-col w-full">
            <div
              v-for="(day, index) in dayArrayAux"
              :key="index"
              class="flex w-full border justify-content-between items-center mb-1"
            >
              <div class="w-1/3 p-2">
                {{ day.name }}
                <p>
                  Núm. horários do dia:
                  {{ dayCounter.get(day.id)[1].count }}
                </p>
              </div>
              <div class="w-2/3 p-2 flex flex-wrap">
                <div v-for="(horario, i) in schedule.schedules" :key="i">
                  <div
                    v-if="
                                            horario.tpdirecao == 2 &&
                                            horario.nudiasemana == day.id
                                        "
                    class="flex items-center justify-content-center mr-2"
                  >
                    <div class="timer-clock-lines">
                      {{ formatHour(horario.hrpartida) }}
                    </div>
                    <FontAwesomeIcon
                      class="text-red-500 cursor-pointer"
                      :icon="faTimesCircle"
                      @click="
                                                deleteSchedule(i, day.id, 2)
                                            "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
